export const PEGA_HEADLESS_WARNING = '@ap/pega-template-content';
